import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Stack } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

function TestCard({ title, description, icon, isSelected, route, onSelect }) {
  console.log(route, isSelected);

  const handleCheckboxChange = (checked) => {
    if (checked !== isSelected) {
      onSelect();
    }
  };

  return (
    <Card
      className={cn(
        "cursor-pointer transition-all hover:shadow-md",
        isSelected && "ring-2 ring-primary bg-primary/5"
      )}
      onClick={onSelect}
    >
      <CardContent className="p-4">
        <div className="flex items-start gap-3">
          <Checkbox
            id={title}
            checked={isSelected}
            onCheckedChange={handleCheckboxChange}
            onClick={(e) => e.stopPropagation()}
            className="mt-1"
          />
          <Label htmlFor={title} className="flex-1 cursor-pointer">
            <Stack spacing="xs">
              <Heading level="h4" className="text-base font-semibold">
                {title}:
              </Heading>
              <Text variant="muted" className="text-sm">
                {description}
              </Text>
            </Stack>
          </Label>
        </div>
      </CardContent>
    </Card>
  );
}

export default React.memo(TestCard);